import { FC } from 'react';
import { Link } from 'react-router-dom';
import colors from 'constants/colors';
import Icon, { IconNames } from 'components/Icon';

interface Props {
  saveForm: () => void;
  type: 'Page' | 'Recipient' | 'Admin' | 'Shopping Cart' | 'Filter';
  isNew?: boolean;
  value?: string;
  setIsPreviewVisible?: (isPreviewVisible: boolean) => void;
  isPreviewVisible?: boolean;
  backTo?: string;
  backLabel?: string;
  readOnly?: boolean;
}

export const DetailHeader: FC<Props> = ({
  saveForm,
  type,
  isNew,
  value = 'Publish',
  setIsPreviewVisible,
  isPreviewVisible,
  backTo,
  backLabel,
  readOnly = false,
}) => {
  return (
    <div className="row filters-row with-padding">
      <div className="grid-column">
        <span className="oath-h3 inkBlue">
          {!isNew ? `Edit your Existing ${type}` : `Create a New ${type}`}
        </span>
        <div className="row gap4">
          <Icon name={IconNames.ChevronLeft} color={colors.white} className="chevron-svg-inkblue" />
          <Link
            to={backTo ?? '..'}
            className="oath-bodysmall inkBlue link-text padding0 self-start"
          >
            {backLabel ?? `Back to All ${type}s`}
          </Link>
        </div>
      </div>
      <div className="row">
        {setIsPreviewVisible && (
          <button
            type="button"
            className="btn-inkBlue-inverted small-button btn-preview btn btn-secondary"
            onClick={() => setIsPreviewVisible(!isPreviewVisible)}
          >
            Preview
          </button>
        )}
        {!readOnly && (
          <button
            type="button"
            className="btn-inkBlue small-button btn btn-secondary"
            onClick={saveForm}
          >
            {value}
          </button>
        )}
      </div>
    </div>
  );
};
